import { http_get } from './helpers';
import { version } from './config';

export const getFileTypes = http_get<
    {id: string; pvId: string},
    any
>(`/api/v${version}/m/ProductDetail/{id}/Models`);
